<!-- Sagdan acilan menu -->


<div ktOffcanvas [options]="panelOptions" [id]="pname" class="kt-demo-panel">
	<div class="kt-demo-panel__head">
		<h3 class="kt-demo-panel__title">
			{{title}}
		</h3>
		<a href="javascript:;" class="kt-demo-panel__close" [id]="close"><i class="flaticon2-delete"></i></a>
	</div>
	<div class="kt-demo-panel__body kt-scroll">
        <ng-content>
            <!-- Icerik, disaridan gonderilir. -->
        </ng-content>
	</div>
</div>